import moment from 'moment'

export const NO_OTP_RECEIVED_MESSAGE = 'No OTP received yet'
export const NO_CODE_EXTRACTED_MESSAGE = 'No code was extracted'

export function canSeeGetLastOtpButton({ isCsmUser, isInternalAdmin } = {}) {
  return Boolean(isCsmUser || isInternalAdmin)
}

export function formatPmsOtpReceivedOn(receivedOn) {
  if (!receivedOn) {
    return ''
  }

  return `${moment.utc(receivedOn).format('MMM DD, YYYY, hh:mm A')} UTC`
}

export function getLastPmsOtpDisplay(lastOtp) {
  if (!lastOtp?.hasOtpMessage) {
    return {
      otpLabel: NO_OTP_RECEIVED_MESSAGE,
      receivedOnLabel: null,
      hasExtractedOtpCode: false,
      isEmpty: true
    }
  }

  return {
    otpLabel: lastOtp.hasExtractedOtpCode
      ? lastOtp.extractedOtpCode
      : NO_CODE_EXTRACTED_MESSAGE,
    receivedOnLabel: formatPmsOtpReceivedOn(lastOtp.receivedOn),
    hasExtractedOtpCode: Boolean(lastOtp.hasExtractedOtpCode),
    isEmpty: false
  }
}
